import styles from './assetsformpage.module.css';

const PRESETS = [
  { id: 'bar', label: 'Barras (Horizontal)' },
  { id: 'column', label: 'Colunas (Vertical)' },
  { id: 'pie', label: 'Pizza' },
  { id: 'donut', label: 'Donut' },
  { id: 'radar', label: 'Radar' },
];

export default function ChartPresetPicker({ value, onChange }) {
  return (
    <div className={styles.presetPicker}>
      <select
        className={styles.selectInput}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
      >
        {PRESETS.map(p => (
          <option key={p.id} value={p.id}>{p.label}</option>
        ))}
      </select>
    </div>
  );
}